export { default } from './SettingMerchant';
